import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const CheckboxFilter = (props) => {
  const [checked, setChecked] = useState(props.checked);

  function handleChange(event) {
    if (event.target.checked) {
      // If the target is checked then we need to update the props state.
      props.setState((oldStateArray) => {
        // We check if it is spreadable, most things are but booleans are not.
        if (oldStateArray !== null && typeof oldStateArray[Symbol.iterator] === 'function') {
          // We also check if the old state was a string. If it is then we don't want to spread
          // the result so that a string of "abc" doesn't become ["a","b","c"].
          if (typeof oldStateArray === 'string') {
            return [oldStateArray, props.value];
          }
          // If the old state is itterable and not a string then we spread and update.
          else {
            return [...oldStateArray, props.value];
          }
        }
        // If its a boolean we just set the state based on the props.
        else {
          return !props.checked;
        }
      });
      setChecked(true);
    } else {
      props.setState((oldStateArray) => {
        // Since we are removing we don't need to check for strings, just return all but the one we are removing.
        if (oldStateArray !== null && typeof oldStateArray[Symbol.iterator] === 'function') {
          return oldStateArray.filter((value) => value !== props.value)
        }
        // or just flip it if we are dealing with a bool.
        else {
          return !props.checked;
        }
      }
      );
      setChecked(false);
    }
  }

  useEffect(() => {
    // If we adjust the state with code then we just change the checked state here too so it matches.
    setChecked(props.checked);
  }, [props.checked]);

  return (
    <label className="form-item__label form-item__label--checkbox form-item__label--checkbox-compact">
      <input
        name={props.name}
        id={props.value}
        type="checkbox"
        className="visually-hidden"
        onChange={handleChange}
        checked={checked}
      />
      <span className="checkmark"></span>
      {props.name}
    </label>
  );
};

CheckboxFilter.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  setState: PropTypes.func,
  checked: PropTypes.bool,
};

export default CheckboxFilter;
